import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import {
  individualAssignmentsStateConfig,
  classAllAssignmentsFetchStateConfig,
  classCurrentAssignmentsFetchStateConfig
} from "../consts";

export const {
  createActionFactory: createAssignmentActionFactory,
  updateActionFactory: updateAssignmentActionFactory,
  deleteActionFactory: deleteAssignmentActionFactory,
  fetchActionFactory: fetchAssignmentActionFactory
} = makeCrudStateActionFactories(individualAssignmentsStateConfig);

export const { fetchActionFactory: fetchCurrentClassAssignmentsActionFactory } =
  makeCrudStateActionFactories(classCurrentAssignmentsFetchStateConfig);

export const { fetchActionFactory: fetchAllClassAssignmentsActionFactory } =
  makeCrudStateActionFactories(classAllAssignmentsFetchStateConfig);
